const listboxConfig={/**
     * Symbol to separate nested options/groups ids
     */idSeparator:"/"};export default listboxConfig;
//# sourceMappingURL=listbox.config.js.map